import axios from 'axios'
import {API_URL} from "./config";
import store from "../store";
import router from '../routes'
import {HANDLE_REFRESH_TOKEN, HANDLE_LOGOUT} from "../store/actions"

const ApiService = {
  init() {
    let url = window.location.host;
    let refreshing_token_in_progress = false;
    if (url == 'genom23f-dev.genomed.pl') {
      axios.defaults.baseURL = API_URL;
    } else {
      axios.defaults.baseURL = "http://" + url + "/api";
    }

    // TODO do zrobienia, żeby poniższe wywołanie działało tylko do naszego API i token nie wyciekał na zewnątrz
    axios.interceptors.request.use(function (config) {
      console.log("First interceptor onFulFilled")
      const token = localStorage.getItem('access_token');
      const refresh_token = localStorage.getItem('refresh_token');
      let is_token_valid = false;
      if (token) {
        let info = JSON.parse(atob(localStorage.getItem('access_token').split('.')[1]));
        let timestamp_now = Date.now() / 1000;
        if (info.exp > timestamp_now) {
          is_token_valid = true;
        } else {
          is_token_valid = false;
        }
      } else {
        console.log("There is no token.");
      }

      if (is_token_valid) {
        console.log("Token is valid, adding to header.");
        config.headers.Authorization = `Bearer ${token}`;
      } else if (!is_token_valid && token) {
        console.log("Token is invalid, trying refreshing.");
        if (!refreshing_token_in_progress) {
          console.log('Refreshing in progress...');
          refreshing_token_in_progress = true;
          store.dispatch(HANDLE_REFRESH_TOKEN, {'refresh_token': refresh_token}).then(
            function (response) {
              localStorage.setItem('access_token', response.data.access);
              console.log('Access token has been refreshed');
              refreshing_token_in_progress = false;
            }).catch(({response}) => {
            console.log('Error refreshing token...');
            if (response.status === 401 && response.data.code == 'token_not_valid' && response.request.responseURL.includes('token/refresh')) {
              store.dispatch(HANDLE_LOGOUT);
              console.log('Redirect to login page');
              router.push('login-view');
            }
            console.log(response);
          });
        } else {
          console.log('In the middle of refreshing...');
        }
      }

      return config;
    }, function (error) {
      return Promise.reject(err);
    });

    // load user if logged in

  }
}

export default ApiService;

export const RegisterService = {
  verify(registration_code) {
    return axios.post('/register/verify', {
      registration_code: registration_code
    })
  },
  register(registration_code, password, email, survey_hash) {
    return axios.post('/register', {
      registration_code: registration_code,
      password: password,
      email: email,
      survey_hash: survey_hash
    })
  }
}

export const AuthService = {
  login(registration_code, password) {
    return axios.post('/token/', {
      registration_code: registration_code,
      password: password
    })
  },
  refresh(refresh_token) {
    return axios.post('/token/refresh/', {
      refresh: refresh_token,
    })
  },
  logout() {
    return axios.post('/logout')
  },
  getUser(user_id) {
    return axios.get('/users/' + user_id);
  }
}

export const ShopService = {
  getCollectionSet() {
    return axios.get('/collection-set');
  },
  orderCollectionSet(payload) {
    return axios.post('collection-set/order', payload)
  },
  orderAnalysis(payload) {
    return axios.post('analysis/order', payload)
  },
  getPackages(payload) {
    return axios.get('analysis-packages')
  },
  getSurvey(payload) {
    return axios.get('surveys/answers/' + payload.id)
  },
  saveSurvey(payload) {
    return axios.post('surveys/answers/' + payload.survey_hash + '/', payload)
  },
  getCountries(payload) {
    return axios.get('countries/')
  },
  getConsultations(payload) {
    return axios.get('consultations/')
  },
  bookConsultation(payload) {
    return axios.post('consultations/' + payload.id + '/book/', payload)
  },
  cancelConsultation(payload) {
    return axios.post('consultations/' + payload.id + '/cancel/', payload)
  },

}

export const AccountService = {
  getUserAnalysisList() {
    return axios.post('/account/analysis/list')
  },
  getSurveysList() {
    return axios.get('surveys/')
  }
}



// WEBPACK FOOTER //
// ./src/common/api.service.js